import moment from "moment";

export const isDateExpired = date => moment(date).startOf("day") < moment().startOf("day");
